import { Stack } from "@altimateai/lego";
import { getIconByDatastoreType } from "../../../DatastoreImage";
import { DatastoreTypeEnum } from "../../../../types";
import { ConnectionStatus } from "../ConnectionStatus";

interface TableauConnectionHeaderProps {
  connectionStatus: "untested" | "success" | "failed";
  isTestingConnection: boolean;
}

export const TableauConnectionHeader = ({
  connectionStatus,
  isTestingConnection,
}: TableauConnectionHeaderProps) => {
  const getRingColorClass = () => {
    const statusClasses: Record<string, string> = {
      success: "al-ring-green-500",
      failed: "al-ring-red-500",
    };
    return statusClasses[connectionStatus] || "al-ring-gray-200";
  };

  return (
    <Stack direction="row" justify="between" className="al-items-center">
      <h3>Connection</h3>
      <Stack direction="column" align="center" gap="xxs">
        <div className={`al-m-2 al-bg-blue-50 rounded al-ring ${getRingColorClass()}`}>
          <Stack direction="row" className="al-items-center al-p-4">
            {getIconByDatastoreType({
              datastoreType: DatastoreTypeEnum.TABLEAU,
              className: "al-w-10 al-h-10 al-mr-3",
            })}
            <span className="al-text-sm">Tableau</span>
          </Stack>
        </div>
        <ConnectionStatus status={connectionStatus} isLoading={isTestingConnection} />
      </Stack>
    </Stack>
  );
};
